import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "selectedShadow"
}
const _hoisted_2 = { style: {"position":"relative"} }
const _hoisted_3 = { style: {"display":"flex","background":"#A42F74","top":"0","right":"0","position":"absolute","border":"2px solid #fff","font-size":"12px","color":"#fff","align-items":"center","gap":"5px","height":"30px","padding":"0 10px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "22",
  viewBox: "0 0 19 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.625 2.396V0.958496H12.375V2.396H6.625ZM8.78125 13.1054H10.2188V7.59495H8.78125V13.1054ZM9.5 21.0595C8.31806 21.0595 7.20399 20.8319 6.15781 20.3767C5.11163 19.9215 4.19722 19.3026 3.41458 18.52C2.63194 17.7373 2.01302 16.8229 1.55781 15.7767C1.1026 14.7305 0.875 13.6165 0.875 12.4345C0.875 11.2526 1.1026 10.1385 1.55781 9.09235C2.01302 8.04617 2.63194 7.13176 3.41458 6.34912C4.19722 5.56648 5.11163 4.94756 6.15781 4.49235C7.20399 4.03714 8.31806 3.80954 9.5 3.80954C10.5701 3.80954 11.5764 3.98923 12.5187 4.3486C13.4611 4.70798 14.2997 5.20711 15.0344 5.846L16.2562 4.62412L17.2625 5.63037L16.0406 6.85225C16.6156 7.49114 17.1068 8.26579 17.5141 9.1762C17.9214 10.0866 18.125 11.1727 18.125 12.4345C18.125 13.6165 17.8974 14.7305 17.4422 15.7767C16.987 16.8229 16.3681 17.7373 15.5854 18.52C14.8028 19.3026 13.8884 19.9215 12.8422 20.3767C11.796 20.8319 10.6819 21.0595 9.5 21.0595ZM9.5 19.622C11.4965 19.622 13.1936 18.9233 14.5911 17.5257C15.9887 16.1281 16.6875 14.4311 16.6875 12.4345C16.6875 10.438 15.9887 8.74096 14.5911 7.34339C13.1936 5.94582 11.4965 5.24704 9.5 5.24704C7.50347 5.24704 5.80642 5.94582 4.40885 7.34339C3.01128 8.74096 2.3125 10.438 2.3125 12.4345C2.3125 14.4311 3.01128 16.1281 4.40885 17.5257C5.80642 18.9233 7.50347 19.622 9.5 19.622Z",
    fill: "white"
  })
], -1)
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "statOuter" }
const _hoisted_7 = {
  key: 0,
  class: "selectedShadow"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "selectedShadow"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "statOuter" }
const _hoisted_13 = {
  key: 0,
  class: "selectedShadow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state === 'Vault')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["card flex justify-center", { 'card-selected': _ctx.selected }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect1 && _ctx.toggleSelect1(...args)))
        }, [
          (_ctx.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.time_convert(_ctx.farmerAcc?.minStakingEndsTs)), 1)
            ]),
            _createElementVNode("img", {
              src: _ctx.nft.externalMetadata.image,
              alt: _ctx.nft.onchainMetadata.data.name
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.selected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.isStaked === 'staked')
              ? (_openBlock(), _createElementBlock("button", _hoisted_8, "Staked"))
              : (_openBlock(), _createElementBlock("button", _hoisted_9, "Unstaked"))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.state === 'Wallet')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["card flex justify-center", { 'card-selected': _ctx.selected }]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect2 && _ctx.toggleSelect2(...args)))
        }, [
          (_ctx.selected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.nft.externalMetadata.image,
            alt: _ctx.nft.onchainMetadata.data.name
          }, null, 8, _hoisted_11),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.selected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selected')))
            }, "Stake")
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}